<template>
  <a-modal
      title="支付详情"
      :visible="visible"
      @cancel="handleCancel"
      :footer="null"
      width="1000px"
  >
    <a-table
        :columns="columns"
        :data-source="details"
        :pagination="false"
        :loading="loading"
        bordered
        size="middle"
        :scroll="{ x: tableScrollX }"
        locale="{ emptyText: '暂无数据' }"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'outboundTime' || column.dataIndex === 'paymentTime'">
          {{ record[column.dataIndex] | formatDate }}
        </template>
        <template
            v-else-if="column.dataIndex === 'amount' || column.dataIndex === 'payAmount' || column.dataIndex === 'discountAmount'">
          {{ record[column.dataIndex] }}元
        </template>
        <template v-else>
          {{ record[column.dataIndex] || '-' }}
        </template>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import moment from 'moment';
import {getPayLogDetail} from "api/app"; // 引入API
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    transactionId: {
      type: String,
      default: null
    },
    barCodeNoSet: {
      type: String,
      default: null
    }
  },
  watch: {
    visible(newVal) {
      if (newVal && this.transactionId) {
        this.fetchDetail();
      }
    }
  },
  created() {
    console.log('details:', this.details);
  },
  computed: {
    tableScrollX() {
      // 计算所有列宽之和
      return this.columns.reduce((sum, col) => sum + (col.width || 120), 0)
    }
  },
  data() {
    return {
      loading: false,
      details: [],
      columns: [
        {
          title: '交易ID',
          dataIndex: 'transactionId',
          width: 150
        },
        {
          title: '标签单号',
          dataIndex: 'barCodeNo',
          width: 150
        },{
          title: '收件地址',
          dataIndex: 'address',
          width: 200
        },
        {
          title: '收件人电话',
          dataIndex: 'toCustTel',
          width: 120
        },
        {
          title: '订单金额',
          dataIndex: 'amount',
          width: 100
        },
        {
          title: '应付金额',
          dataIndex: 'payAmount',
          width: 100
        },
        {
          title: '优惠金额',
          dataIndex: 'discountAmount',
          width: 100
        },
        {
          title: '支付来源',
          dataIndex: 'paymentSource',
          width: 100
        },
        {
          title: '出库时间',
          dataIndex: 'outboundTime',
          width: 150
        },
        {
          title: '支付时间',
          dataIndex: 'paymentTime',
          width: 150
        }
      ]
    };
  },
  filters: {
    formatDate(value) {
      return value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : '-';
    }
  },
  methods: {
    async fetchDetail() {
      this.loading = true;
      try {
        const response = await getPayLogDetail({
          transactionId: this.transactionId,
          barCodeNoSet: this.barCodeNoSet
        });

        if (response && response.data) {
          this.details = Array.isArray(response.data)
              ? response.data
              : [response.data];
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        this.$message.error("获取详情失败");
      } finally {
        this.loading = false;
      }
    },
    handleCancel() {
      this.details = []
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.ant-table {
  margin-top: -16px;
}
</style>
